import { createFileRoute } from '@tanstack/react-router';
import { ListingsPage } from '@/features/marketing/listings/listings-page';

/** Marketing › Listings: the salon's info on the directories (shown while the agency has Listings on). */
export const Route = createFileRoute('/_auth/$orgId/marketing/listings')({
  component: ListingsRoute,
});

function ListingsRoute() {
  const { orgId } = Route.useParams();
  return <ListingsPage routeOrgId={orgId} />;
}
